import React, { useState, useEffect, useRef } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useSelector, useDispatch } from "react-redux";
import { InputGroup, Accordion } from "react-bootstrap";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Button } from "bootstrap-4-react/lib/components";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import noImage from "../../../assets/No-Image-Placeholder.png";
import IconButton from '@material-ui/core/IconButton';
import {
    createproduct,
    getProductConditionList,
    getProductDetails,
    getProductProcessTypeList,
    getProductStatusList,
    getProductWarehouseList,
    resetProduct,
    updateMediaForProduct,
    updateproduct,
} from "../../../store/actions/incoming";
import moment from "moment";
import LoaderSpinner from "../../common/Loader";
import { allowedExtensions, ItemTypeList, ReturnProductTypeList, videoallowedExtensions } from "../../../constant";
import ImageSlider from "../ImageSlider";
import InLargeImageSlider from "../../modal/InlargeImageSlider";
import { handleDocsUpload, getSelectList, computeAutoSelectedSeller } from "../../../config/utils";
import { getAllCompanyDetails } from "../../../store/actions/rateCard";
import { getSellersforMultipleCompany } from "../../../store/actions/company";
import Select from 'react-select';
import { getAllCountries } from "../../../store/actions";
import RenderVideos from "./RenderVideos";
import RenderImages from "./images";
import WarehouseDetails from "../../Inventory/Product/WarehouseDetails";
import _ from "lodash";
import BarcodeBtn from "../../Inventory/Product/BarcodeBtn";
import BarcodeScannerComponent from "../../common/BarCodeScanner";
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { Tooltip } from "@material-ui/core";
import AddTaskModal from "./AddTaskModal";
import PostChargesModal from "./PostChargesModal";
import TasksChargesHistoryModal from "./TasksChargesHistoryModal";
import { isDefaultSuperAdminRole, isSuperAdminRole } from "../../../constants/roleConstants";
// Shared styles for Select components
const selectStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: '28px',
    height: '36px',
    fontSize: '13px',
    paddingTop: '0.5px'
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#515558ff'
  })
};

/*istanbul ignore next */
const EditProduct = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { view, date, landingSearch, trackingNumber, productType } = location?.state || {};
    const userDetails = useSelector((state) => state.auth.user);
    const videoInputRef = useRef(null);
    const [image, setImage] = useState([]);
    const [showBeforeProcessingModal, setShowBeforeProcessingModal] = useState(false);
    const [showAfterProcessingModal, setShowAfterProcessingModal] = useState(false);
    const [showPackageImagesModal, setShowPackageImagesModal] = useState(false);
    const { warehouseList } = useSelector((state) => state.InventoryManagement);
    const [attachments, setAttachments] = useState([]);
    const [afterImage, setAfterImage] = useState([]);
    const [error, setErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const [video, setVideo] = useState();
    const [isFormEdited, setIsFormEdited] = useState(false);
    const [deletedWareHouses, setDeletedWareHouses] = useState([]);
    const [selectedScannedData, setSelectedScannedData] = useState({});
    const [showScanner, setShowScanner] = useState(false);
    const [showAddTaskModal, setShowAddTaskModal] = useState(false);
    const [showPostChargesModal, setShowPostChargesModal] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false);
    const UserValue = useSelector((state) => state.auth.user);
    const isSuperAdminUser = isSuperAdminRole(UserValue?.Value);
    const isDefaultSuperAdminUser = isDefaultSuperAdminRole(UserValue?.Value);
    const countries = useSelector((state) => state.shipment.countries);
    const productDetailsById = useSelector(
        (state) => state?.IncomingProductReducer?.productDetailsById
    );
    const productDetailStatus = useSelector(
        (state) => state?.IncomingProductReducer?.productDetailStatus
    );
    const productStatusList = useSelector(
        (state) => state?.IncomingProductReducer?.productStatusList
    );
    const productConditionList = useSelector(
        (state) => state?.IncomingProductReducer?.productConditionList
    );
    const productWarehouseList = useSelector(
        (state) => state?.IncomingProductReducer?.productWarehouseList
    );
    const productProcessList = useSelector(
        (state) => state?.IncomingProductReducer?.productProcessList
    );

    const productsList = useSelector(
        (state) => state.IncomingProductReducer?.productsList
      );
    
    // Company and Seller selectors
    const { getAllCompany } = useSelector((state) => state.RateCardReducer);
    const getSellersValue = useSelector((state) => state.company?.getMultipleCompanySellers);
    const [formData, setFormData] = useState({
        modifiedDate: new Date(),
        createdDate: new Date(),
        modifiedBy: UserValue?.Value?.employeeId,
        incomingDate: new Date(),
        countryOfOrigin: '218',
        companyId: 0,
        sellerId: 0,
        returnProductType: '',
        wareHouseDetails: [{
            id: 0,
            quantity: 0,
            areaId: 0,
            rowId: 0,
            bayId: 0,
            levelId: 0,
            positionId: 0,
            inboundProductId: 0,
            warehouseId: 0,
            warehouseBinLocationId: 0,
            warehouse: '',
            area: '',
            row: '',
            bay: '',
            level: '',
            position: '',
        }]
    });

    // Company and Seller dropdown state
    const [companyList, setCompanyList] = useState([]);
    const [sellerList, setSellerList] = useState([]);

    const dispatch = useDispatch();
    let { id } = useParams();
    let isCreateForm = parseInt(id) === 0; // NOSONAR

    useEffect(() => {
        if (parseInt(id) !== 0) { // NOSONAR
            dispatch(getProductDetails(id));
        }
    }, [id]);

    useEffect(() => () => {
        dispatch(resetProduct());
    }, []);

    useEffect(() => {
        if (!countries.length) {
            dispatch(getAllCountries());
        }
    }, [countries]);

    useEffect(() => {
        // Get all company details for dropdown (only for super admin and edit mode)
        if (isSuperAdminUser && !isCreateForm) {
            dispatch(getAllCompanyDetails(null, 500, 1)); // Use same parameters as Tasks component
        }
    }, [isSuperAdminUser, isCreateForm]);

    useEffect(() => {
        // For existing product, if it has companyId, fetch sellers for that company (only for super admin)
        if (isSuperAdminUser && productDetailsById?.companyId) {
            dispatch(getSellersforMultipleCompany([productDetailsById.companyId]));
        }
        
        if (parseInt(id) !== 0) { // NOSONAR
            let updatedFormData = {
                ...JSON.parse(JSON.stringify(productDetailsById)),
                companySellerId: UserValue?.Value?.companySellerId,
            };
            setFormData(updatedFormData);
            if (productDetailsById?.attachments?.length) {
                setAttachments({ ...productDetailsById.attachments });
            }
        }
    }, [productDetailsById, isSuperAdminUser]);

    useEffect(() => {
        if (!productStatusList?.length) {
            dispatch(getProductStatusList());
        }
        if (!productConditionList?.length) {
            dispatch(getProductConditionList());
        }
        if (!productWarehouseList?.length) {
            dispatch(getProductWarehouseList());
        }
        if (!productProcessList?.length) {
            dispatch(getProductProcessTypeList());
        }
    }, []);

    useEffect(() => {
        if (parseInt(id) !== 0) { // NOSONAR
            let cloneFormData = JSON.parse(JSON.stringify(productDetailsById));
            cloneFormData.isInventoryType = cloneFormData?.isInventoryType ? 1 : 0;
            setFormData(cloneFormData);
            if (productDetailsById?.attachments?.length) {
                setAttachments({ ...productDetailsById.attachments });
            }
        }
    }, [productDetailsById]);

    useEffect(() => {
        if (productDetailStatus === "pending") {
            setLoader(true);
        } else {
            setLoader(false);
        }
    }, [productDetailStatus]);

    // Populate company list for dropdown (only for super admin)
    useEffect(() => {
        let companyData = getAllCompany?.Entity?.listCompanyMasterOrdersEntity || [];
        if (companyData.length) {
            // map to { value, label } - exact same as Tasks and EditPackage
            const companies = getSelectList(companyData, 'Id', 'name');
            setCompanyList(companies);
        }

        let sellerData = getSellersValue?.Entity?.listSellerMasterOrdersEntity || [];
        if (sellerData.length) {
            const sellers = getSelectList(sellerData, 'id', 'sellerAndCompany');
            setSellerList(sellers);
            // Auto-select the lone seller when the selected company has exactly one
            const lone = computeAutoSelectedSeller(sellerData);
            if (lone) {
                setFormData(prev => (Number(prev?.sellerId) ? prev : { ...prev, sellerId: lone.id }));
            }
        } else {
            setSellerList([]);
        }
    }, [getAllCompany, getSellersValue]);

    const validateForm = () => {
        const errorData = {};

        // Seller-specific validation
        if (UserValue?.Value?.roleName === "Seller" && !formData?.notes) {
            errorData.notes = "Notes is required";
        }

        // Common required fields
        const requiredFields = [
            "inboundProductCondition_Id",
            "sku",
            "itemName",
            "additionalProductId",
            "productDescription",
            "inboundProductStatus_Id"
        ];

        requiredFields.forEach((field) => {
            if (!formData?.[field]) {
                errorData[field] = "This is required";
            }
        });

        // Special case check
        if (formData?.isInventoryType === "") {
            errorData.isInventoryType = "This is required";
        }

        setErrors(errorData);

        return Object.keys(errorData).length === 0;
    };

    const validateCreateForm = () => {
        let isValid = true;
        let errorData = {};
        if (
            formData?.inboundProductCondition_Id == "0" ||
            formData?.inboundProductCondition_Id == undefined
        ) {
            isValid = false;
            errorData.inboundProductCondition_Id = "This is required";
        }
        if (!formData?.sku) {
            isValid = false;
            errorData.sku = "This is required";
        }
        if (!formData?.itemName) {
            isValid = false;
            errorData.itemName = "This is required";
        }
        if (!formData?.additionalProductId) {
            isValid = false;
            errorData.additionalProductId = "This is required";
        }
        if (!formData?.productDescription) {
            isValid = false;
            errorData.productDescription = "This is required";
        }
        if (!formData?.inboundProductStatus_Id) {
            isValid = false;
            errorData.inboundProductStatus_Id = "This is required";
        }
        if (formData?.isInventoryType === "") {
            isValid = false;
            errorData.isInventoryType = "This is required";
        }
        setErrors(errorData);
        return isValid;
    };

    const handleFormChange = (e) => {
        const { value, name } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });
        setErrors({
            ...error,
            [name]: "",
        });
        setIsFormEdited(true);
    };

    const handleSliderDeleteImage = (e, item) => {
        let formDataCopyObj = JSON.parse(JSON.stringify(formData));
        let updateBeforeProcessingImages =
            formDataCopyObj.beforeProcessingImages.map((imagePack) => {
                return {
                    ...imagePack,
                    isDeleted: item.id === imagePack.id ? true : false,
                };
            });
        let updateAfterProcessingImages = formDataCopyObj.afterProcessingImages.map(
            (imagePack) => {
                return {
                    ...imagePack,
                    isDeleted: item.id === imagePack.id ? true : false,
                };
            }
        );

        if (updateBeforeProcessingImages.length) {
            formDataCopyObj.beforeProcessingImages = updateBeforeProcessingImages;
        }
        if (updateAfterProcessingImages.length) {
            formDataCopyObj.afterProcessingImages = updateAfterProcessingImages;
        }

        setIsFormEdited(true);
        setFormData(formDataCopyObj);
    };

    const handleMarkPrimary = (e, item) => {
        let formDataCopyObj = JSON.parse(JSON.stringify(formData));

        let updateBeforeProcessingImages =
            formDataCopyObj.beforeProcessingImages.map((imagePack) => {
                return {
                    ...imagePack,
                    isPrimary: item.id === imagePack.id ? true : false,
                };
            });
        let updateAfterProcessingImages = formDataCopyObj.afterProcessingImages.map(
            (imagePack) => {
                return {
                    ...imagePack,
                    isPrimary: item.id === imagePack.id ? true : false,
                };
            }
        );
        formDataCopyObj.beforeProcessingImages = updateBeforeProcessingImages;
        formDataCopyObj.afterProcessingImages = updateAfterProcessingImages;
        setFormData(formDataCopyObj);
        setIsFormEdited(true);
    };

    const handleCreateForm = async () => {
        let data = { ...formData };
        data.createdBy = UserValue?.Value?.employeeId;
        setLoader(true);

        try {
            let response = await createproduct(data);
            if (response && response?.data?.Status === 200) {
                let uploadData = new FormData();
                uploadData.append("id", response?.data?.Entity);
                uploadData.append("modifiedBy", UserValue?.Value?.employeeId);
                uploadData = appendFilesToUploadData(uploadData, video, 'video');
                uploadData = appendFilesToUploadData(uploadData, image, 'beforeProcessingImages');
                uploadData = appendFilesToUploadData(uploadData, afterImage, 'afterProcessingImages');
                uploadData = appendFilesToUploadData(uploadData, attachments, 'attachments');

                let uploadRes = await updateMediaForProduct(uploadData);
                if (uploadRes && uploadRes?.data?.Status === 200) {
                    navigate(`/incoming-products`, { state: { view: true, date: location?.state?.date } });
                    setIsFormEdited(false);
                    toast.success("Changes Saved Successfully");
                    dispatch(getProductDetails(response?.data?.Entity));
                    setVideo(null);
                    setImage([]);
                    setAttachments([]);
                    setAfterImage([]);
                } else if (!uploadRes?.data?._readOnlyBlocked) {
                    toast.error(uploadRes?.data?.Message?.AppStatusDescription || response?.data?.Message?.AppStatusDescription);
                }
            } else if (!response?.data?._readOnlyBlocked) {
                toast.error(response?.data?.Message?.AppStatusDescription || 'Failed to create product');
            }
        } catch (err) {
            if (!err?.response?.data?._readOnlyBlocked && !err?._impersonationExpired) {
                toast.error(err?.response?.data?.Message?.AppStatusDescription || 'Failed to create product');
            }
        } finally {
            setLoader(false);
        }
    }

    const appendFilesToUploadData = (uploadData, files, key) => {
        if (files) {
            for (let i = 0; i < files.length; i++) {
                uploadData.append(key, files[i]);
            }
        }
        return uploadData;
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (isCreateForm) {
            if (validateCreateForm()) {
                handleCreateForm();
            } else {
                toast.error('Validation Failed');
            }
        } else if (validateForm()) {
                setLoader(true);
                let updateRes = JSON.parse(JSON.stringify(formData));
                updateRes.companySellerId = UserValue?.Value?.companySellerId;
                updateRes.modifiedBy = UserValue?.Value?.employeeId;
                updateRes.imageActions = [...updateRes.afterProcessingImages.filter((item) => item.isPrimary || item.isDeleted),
                ...updateRes.beforeProcessingImages.filter(
                    (item) => item.isPrimary || item.isDeleted
                )];
                updateRes.attachmentActions = [...updateRes.attachments.filter((item) => item.isDeleted)];
                handleUpdateProduct(updateRes);
            }
    };

    const handleUpdateProduct = async (updateRes) => {
        // Rename fields for API payload
        if (updateRes.companyId !== undefined) {
            updateRes.assignedToCompanyId = updateRes.companyId;
            delete updateRes.companyId;
        }
        if (updateRes.sellerId !== undefined) {
            updateRes.assignedToSellerId = updateRes.sellerId;
            delete updateRes.sellerId;
        }

        try {
            let response = await updateproduct(updateRes);
            if (response && response?.data?.Status === 200) {
                let uploadData = new FormData();
                uploadData.append("id", id);
                uploadData.append("modifiedBy", 1);

                uploadData = appendFilesToUploadData(uploadData, video, 'video');
                uploadData = appendFilesToUploadData(uploadData, image, 'beforeProcessingImages');
                uploadData = appendFilesToUploadData(uploadData, afterImage, 'afterProcessingImages');
                uploadData = appendFilesToUploadData(uploadData, attachments, 'attachments');

                let uploadRes = await updateMediaForProduct(uploadData);
                if (uploadRes && uploadRes?.data?.Status === 200) {
                    navigate(
                        `/incoming-product/fd-${new Date(
                            formData.createdDate
                        ).toISOString()}-3pl/${id}`,
                        {
                            state: {
                                view: true,
                                date: location?.state?.date,
                                landingSearch,
                                trackingNumber,
                                productType: productType,
                            },
                        }
                    );

                    toast.success("Changes Saved Successfully");
                    setIsFormEdited(false);
                    dispatch(getProductDetails(id));
                    setVideo(null);
                    setImage([]);
                    setAfterImage([]);
                } else if (!uploadRes?.data?._readOnlyBlocked) {
                    toast.error(uploadRes?.data?.Message?.AppStatusDescription || response?.data?.Message?.AppStatusDescription);
                }
            } else if (!response?.data?._readOnlyBlocked) {
                toast.error(response?.data?.Message?.AppStatusDescription || 'Failed to update product');
            }
        } catch (err) {
            if (!err?.response?.data?._readOnlyBlocked && !err?._impersonationExpired) {
                toast.error(err?.response?.data?.Message?.AppStatusDescription || 'Failed to update product');
            }
        } finally {
            setLoader(false);
        }
    }

    const handleImageUpload = (e) => {
        let files = [...e.target.files];
        try {
            if (files.length > 0 && files.length <= 5) {
                let filterFiles = files.filter((file, index) => {
                    const extension = file.name.split(".").slice(-1).pop();
                    const fileSize = Math.round(file.size / 1024);

                    if (
                        !allowedExtensions.includes(
                            extension ? extension.toLowerCase() : ""
                        )
                    ) {
                        files.splice(index, 1);
                        toast.error("Unsupported File format", 1000);

                        return false;
                    } else if (fileSize > 1024) {
                        files.splice(index, 1);
                        e.target.value = "";
                        toast.info("Each picture size should be less than 1MB", 1000);
                        return false;
                    }
                    return file;
                });

                setErrors({ ...error, image: "" });
                setImage(filterFiles);
                setIsFormEdited(true);



            } else if (files.length > 5) {
                toast.info("5 images can be upload at one time", 1000);
                e.target.value = "";
            } else {
                e.target.value = "";
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleDeleteImage = (index) => {
        let images = [...image];
        images.splice(index, 1);
        setImage(images);
    };

    const handleDeleteAfterImage = (index, type = '') => {
        if (type === 'attachments') {
            let attachmentsList = [...attachments];
            if (attachmentsList[index].id) {
                attachmentsList[index].isDeleted = true;
            } else {
                attachmentsList.splice(index, 1);
            }
            setAttachments(attachmentsList);
        } else {
            let afterimages = [...afterImage];
            afterimages.splice(index, 1);
            setAfterImage(afterimages);
        }
    };

    const handleAfterImageUpload = (e) => {
        let files = [...e.target.files];
        try {
            if (files.length > 0 && files.length <= 5) {
                let filterFiles = files.filter((file, index) => {
                    const extension = file.name.split(".").slice(-1).pop();
                    const fileSize = Math.round(file.size / 1024);

                    if (
                        !allowedExtensions.includes(
                            extension ? extension.toLowerCase() : ""
                        )
                    ) {
                        files.splice(index, 1);
                        toast.error("Unsupported File format", 1000);
                        return false;
                    } else if (fileSize > 1024) {
                        files.splice(index, 1);
                        e.target.value = "";
                        toast.info("Each picture size should be less than 1MB", 1000);
                        return false;
                    }
                    return file;
                });
                setErrors({ ...error, image: "" });
                setAfterImage(filterFiles);
                setIsFormEdited(true);

            } else if (files.length > 5) {

                toast.error("5 images can be upload at one time", 1000);
                e.target.value = "";
            } else {
                e.target.value = "";
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleVideoUpload = (e) => {
        let files = [...e.target.files];
        try {
            if (files.length > 0 && files.length <= 5) {
                let filterFiles = files.filter((file, index) => {
                    const extension = file.name.split(".").slice(-1).pop();
                    const fileSize = file.size / (1024 * 1024); // Convert size to MB


                    if (fileSize > 10) {
                        files.splice(index, 1);
                        toast.error("Video size should be less than 10MB", 1000);
                        e.target.value = "";
                        return false;
                    } else if (
                        !videoallowedExtensions.includes(
                            extension ? extension.toLowerCase() : ""
                        )
                    ) {
                        files.splice(index, 1);
                        toast.error("Unsupported file format", 1000);
                        return false;
                    }
                    return file;
                });
                setErrors({ ...error, video: "" });
                setVideo(filterFiles);
                setIsFormEdited(true);
                if (e.target.files.length !== files.length) {
                    toast.info("Each video size should be less than 10MB", 1000);
                    e.target.value = "";
                }
            } else if (files.length > 5) {
                toast.info("Up to 5 videos can be uploaded at one time", 1000);
                e.target.value = "";
            } else {
                e.target.value = "";
            }
        } catch (err) {
            console.log(err);
        }
    };

    const handleEdit = () => {
        navigate(`/incoming-product/fd-${date}-3pl/${id}`, {
            state: {
                view: false,
                date: location?.state?.date,
                landingSearch,
                trackingNumber,
            },
        });
    };

    const handleBack = () => {
        if (isCreateForm) {
            navigate(`/incoming-products`);
        } else if (landingSearch || landingSearch === "") {
            navigate(`/incoming-products/product-details`, {
                state: { dateValue: location?.state?.date, searchTxt: landingSearch },
            });
        } else if (trackingNumber) {
            navigate(`/incoming-products/product-details`, {
                state: { trackingNumber },
            });
        } else if (productType === "allProducts") {
            navigate(`/incoming-product-listing`, {
            });
        } else {
            navigate(`/incoming-products/product-details`, {
                state: { date: location?.state?.date, searchTxt: landingSearch },
            });
        }
    };

    const handleDateChange = (value, name) => {
        setFormData({
            ...formData,
            [name]: moment(value).format("MM-DD-YYYY"),
        });

        setIsFormEdited(true);
    };

    useEffect(() => {
        formData?.wareHouseDetails?.forEach((warehouse, index) => {
            if (warehouse?.id) {
                let warehouseListData = warehouseList?.filter(
                    (item) => item.id === Number(warehouse?.warehouseId)
                );
                let updatedWareHouseDetails = [...(formData?.wareHouseDetails || [])];
                if (warehouseListData?.length > 0) {
                    updatedWareHouseDetails[index].address = warehouseListData[0];
                }
                setFormData((prevState) => ({
                    ...prevState,
                    wareHouseDetails: updatedWareHouseDetails,
                }));
            }
        });
    }, [warehouseList]);

    const handleUpdateDeleteVideo = () => {
        setFormData({
            ...formData,
            videoUrl: "",
            deleteVideo: true,
        });
        setIsFormEdited(true);
    };

    const renderTitle = () => {
        let title;
        if (parseInt(id) === 0) { // NOSONAR
            title = "Create Product";
        } else if (!view) {
            title = "Edit Product Details";
        } else {
            title = "Product Details";
        }
        return title
    }

    const addWarehouse = () => {
        let data = { ...formData };
        data.wareHouseDetails.push({ wareHouseName: "", quantity: 1, id: 0 });
        setIsFormEdited(true);
        setFormData(data);
    };

    const removeWarehouse = (index) => {
        let data = { ...formData };
        if (Number(id) > 0) {
            let deletedWareHouseList = [...deletedWareHouses];
            deletedWareHouseList.push(data.wareHouseDetails[index].id)
            setDeletedWareHouses(deletedWareHouseList);
        }
        data.wareHouseDetails.splice(index, 1);
        setFormData(data);
        setIsFormEdited(true);
    };

    const handleWarehouse = (e, index, isNumber = false) => {
        setIsFormEdited(true);
        const { value, name } = e.target;
        let data = _.cloneDeep(formData);
        data.wareHouseDetails[index][name] = isNumber ? Number(value) : value;
        if (name === "warehouseId") {
            let warehouseListData = warehouseList?.filter(
                (item) => item.id === Number(value)
            );
            data.wareHouseDetails[index].address = warehouseListData[0];
            data.wareHouseDetails[index].areaId = 0;
            data.wareHouseDetails[index].rowId = 0;
            data.wareHouseDetails[index].bayId = 0;
            data.wareHouseDetails[index].levelId = 0;
            data.wareHouseDetails[index].positionId = 0;
        }
        if (name === 'itemExpiryDate' || name === 'productExpiry') {
            let dateSelected = moment(value).format("MM-DD-YYYY");
            data.wareHouseDetails[index][name] = dateSelected;
        }
        setFormData(data);
    };

    const updateWareHouseDetails = (index, name, list) => {
        let data = { ...formData };
        data.wareHouseDetails[index][name] = list;
        setFormData(data);
    };

    const handleInputBlur = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value.trim() });
    };

    const handleOpenScan = (e, inputKey) => {
        e.preventDefault();
        setSelectedScannedData({ formKey: inputKey });
        setShowScanner(!showScanner);
    }

    const handleScanSuccess = (scannedValue) => {
        setFormData({
            ...formData,
            [selectedScannedData.formKey]: scannedValue
        });
        setShowScanner(false);
    };

    const handleProductNavigation = (direction) => {
        let currentIndex = -1;
        if (!productsList?.length) {
            return;
        }
        currentIndex = productsList.findIndex(
            (product) => product.id === Number(id)
        );

        if (direction === 'next') {
            if (currentIndex === productsList.length - 1) {
                toast.info("You've reached the last product.", { autoClose: 1000 });
                return;
            }
            const nextProductId = productsList[currentIndex + 1].id;
            navigate(`/incoming-product/fd-${date}-3pl/${nextProductId}`, {
                state: {
                    view: true,
                    date: location?.state?.date,
                    landingSearch,
                    trackingNumber,
                    productType,
                },
            });
        }
        
        if (direction === 'previous') {
            if (currentIndex === 0) {
                toast.info("You've reached the first product.", { autoClose: 1000 });
                return;
            }
            const previousProductId = productsList[currentIndex - 1].id;
            navigate(`/incoming-product/fd-${date}-3pl/${previousProductId}`, {
                state: {
                    view: true,
                    date: location?.state?.date,
                    landingSearch,
                    trackingNumber,
                    productType,
                },
            });
        }
    };

    const handleGotoPackage = () => {
        let date = location?.state?.date || moment().format('YYYY-MM-DD');
        const url = `/incoming-packages/fd-${date}-3pl/${formData.inboundParcelId}`;
        window.open(url, "_blank");
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    <span>
                        {renderTitle()}
                        {!isCreateForm && (
                            <Tooltip title="View Tasks & Charges History">
                                <IconButton
                                    aria-label="View Tasks & Charges History"
                                    size="small"
                                    style={{ marginLeft: 6 }}
                                    onClick={() => setShowHistoryModal(true)}
                                >
                                    <i className="fa fa-info-circle" aria-hidden="true" style={{ color: "#ff0000" }}></i>
                                </IconButton>
                            </Tooltip>
                        )}
                    </span>
                    <div></div>
                    <div className="top_right_button_container">
                        {productsList?.length > 1 && !isCreateForm && (
                            <>
                                <Tooltip title="Load previous product">
                                    <IconButton color="primary" aria-label="Previous product" onClick={() => handleProductNavigation('previous')} disabled={loader}>
                                        <NavigateBeforeIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Load next product">
                                    <IconButton color="primary" aria-label="Next product" onClick={() => handleProductNavigation('next')} disabled={loader}>
                                        <NavigateNextIcon />
                                    </IconButton>
                                </Tooltip>
                            </>
                        )}

                        {!isCreateForm && (
                            <>
                                <button
                                    type="button"
                                    className="btn cus-seconday-bg-btn top-btn"
                                    id="addProductTask"
                                    disabled={loader}
                                    onClick={() => setShowAddTaskModal(true)}
                                >
                                    <i className="fa fa-plus" aria-hidden="true"></i> Add Task
                                </button>
                                {isDefaultSuperAdminUser && (
                                    <button
                                        type="button"
                                        className="btn cus-seconday-bg-btn top-btn"
                                        id="postProductCharges"
                                        disabled={loader}
                                        onClick={() => setShowPostChargesModal(true)}
                                    >
                                        <i className="fa fa-plus" aria-hidden="true"></i> Post Charges
                                    </button>
                                )}
                            </>
                        )}

                        <button
                            disabled={!isFormEdited}
                            className="btn cus-seconday-bg-btn top-btn"
                            id="savesr"
                            onClick={handleSave}
                        >
                            Save
                        </button>
                        {!isCreateForm && (
                            <Button
                                disabled={!view}
                                className="cus-seconday-bg-btn top-btn"
                                id="hde"
                                onClick={handleEdit}
                            >
                                Edit
                            </Button>
                        )}
                        <Button
                            className="cus-primary-transparent-btn top-btn"
                            id="hdb"
                            disabled={loader}
                            onClick={() => handleBack()}
                        >
                            Back
                        </Button>
                    </div>
                </div>
                {loader && (<div className="full-screen-spinner-overlay"><LoaderSpinner /></div>)}
                <div className="main_content cus-page-content-sec">
                    <div className="top_right_button_container cus-content-only-sec">
                        <div className="incoming_wrapper incomingAccordion accordion pt-2">
                            <div className="row fontFix">
                                <div className={parseInt(id) === 0 ? "col-12" : "col-lg-8 col-sm-12"}> {/* NOSONAR */}
                                    <Row className="p-2">
                                        <Col xs={12} lg={12}>
                                            <Accordion
                                                defaultActiveKey={["0", "1", "2", "3", "4", "5"]}
                                                alwaysOpen={true}
                                            >
                                                <Accordion.Item eventKey="0">
                                                    <Accordion.Header>
                                                        Details {" "}
                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className="row addressForm pl-3 pr-3">
                                                            {/* Company and Seller Dropdowns - Only for Edit mode and Super Admin */}
                                                            {isSuperAdminUser && !isCreateForm && (
                                                                <>
                                                                    <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                        <div className="input-label-txt">
                                                                            Company {!!(formData.sellerId && formData.sellerId !== 0) && <span className="require-field">*</span>}
                                                                        </div>
                                                                        <div className="select_react">
                                                                            <Select
                                                                                options={companyList}
                                                                                onChange={(opt) => {
                                                                                    const val = opt?.value || 0;
                                                                                    setFormData(prev => ({ 
                                                                                        ...prev, 
                                                                                        companyId: val, 
                                                                                        sellerId: 0 // Reset seller when company changes
                                                                                    }));
                                                                                    setIsFormEdited(true); // Enable save button when company changes
                                                                                    // fetch sellers for selected company
                                                                                    if (val && val !== 0) {
                                                                                        dispatch(getSellersforMultipleCompany([val]));
                                                                                    }
                                                                                }}
                                                                                className="activeSellerListInput"
                                                                                isDisabled={view} // Only disable for view mode since we're only showing in edit mode
                                                                                value={companyList?.find(c => c.value === formData.companyId) || null}
                                                                                placeholder="Select Company..."
                                                                                isMulti={false}
                                                                                classNamePrefix="list-value"
                                                                                styles={selectStyles}
                                                                            />
                                                                        </div>
                                                                        {error.companyId && (
                                                                            <div className="requiredthis">
                                                                                *{error.companyId}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                        <div className="input-label-txt">
                                                                            Seller {!!(formData.companyId && formData.companyId !== 0) && <span className="require-field">*</span>}
                                                                        </div>
                                                                        <div className="select_react">
                                                                            <Select
                                                                                options={sellerList}
                                                                                onChange={(opt) => {
                                                                                    setFormData(prev => ({ ...prev, sellerId: opt?.value || 0 }));
                                                                                    setIsFormEdited(true); // Enable save button when seller changes
                                                                                }}
                                                                                className="activeSellerListInput"
                                                                                isDisabled={view} // Only disable for view mode since we're only showing in edit mode
                                                                                value={sellerList?.find(s => s.value === formData.sellerId) || null}
                                                                                placeholder="Select Seller..."
                                                                                isMulti={false}
                                                                                classNamePrefix="list-value"
                                                                                styles={selectStyles}
                                                                            />
                                                                        </div>
                                                                        {error.sellerId && (
                                                                            <div className="requiredthis">
                                                                                *{error.sellerId}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            )}
                                                            
                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-1">
                                                                <InputGroup>
                                                                    <div className="input-label-txt">
                                                                        Return Product SKU (Stock Keeping Unit) <span className="require-field">*</span>
                                                                    </div>
                                                                    <div className="generateSkuInputWrapper">
                                                                        <div className='flexCenter'>
                                                                            <input
                                                                                disabled={view}
                                                                                onChange={handleFormChange}
                                                                                value={formData?.sku}
                                                                                name={"sku"}
                                                                                className="form-control"
                                                                                maxLength={100}
                                                                            />
                                                                            <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="sku" />
                                                                        </div>
                                                                    </div>
                                                                    {error.sku && (
                                                                        <div className="requiredthis">
                                                                            *This is required
                                                                        </div>
                                                                    )}
                                                                </InputGroup>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Product Name <span className="require-field">*</span>
                                                                </div>
                                                                <div className="input-box">
                                                                    <input
                                                                        disabled={view}
                                                                        onChange={handleFormChange}
                                                                        value={formData?.itemName}
                                                                        name={"itemName"}
                                                                        className="form-control"
                                                                        maxLength={100}
                                                                    />
                                                                </div>
                                                                {error.itemName && (
                                                                    <div className="requiredthis">
                                                                        *This is required
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Product Description <span className="require-field">*</span>
                                                                </div>
                                                                <div className="input-box">
                                                                    <input
                                                                        disabled={view}
                                                                        onChange={handleFormChange}
                                                                        value={formData?.productDescription}
                                                                        name={"productDescription"}
                                                                        className="form-control"
                                                                        maxLength={100}
                                                                    />
                                                                </div>
                                                                {error.productDescription && (
                                                                    <div className="requiredthis">
                                                                        *This is required
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Return Product Type <span className="require-field">*</span>
                                                                </div>
                                                                <div className="input-box">
                                                                    <select
                                                                        disabled={view}
                                                                        onChange={(e) => {
                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                isInventoryType: e.target.value
                                                                                    ? Number(e.target.value)
                                                                                    : ""
                                                                                }))
                                                                                setErrors({
                                                                                    ...error,
                                                                                    isInventoryType: "",
                                                                                });
                                                                                setIsFormEdited(true);
                                                                            }
                                                                        }
                                                                        value={formData?.isInventoryType ?? ""}
                                                                        name={"isInventoryType"}
                                                                        className="form-control noMarginBtm"
                                                                    >
                                                                        <option value="">Select</option>
                                                                        {ReturnProductTypeList.map((item, index) => (
                                                                            <option key={item.id} value={item.id}>
                                                                                {item.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                                {error.isInventoryType && (
                                                                    <div className="requiredthis">
                                                                        *This is required
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">Item Type</div>
                                                                <div className="generateSkuInputWrapper">
                                                                    <div className='flexCenter'>
                                                                        <select
                                                                            disabled={view}
                                                                            onChange={handleFormChange}
                                                                            value={formData?.itemType}
                                                                            name={"itemType"}
                                                                            className="form-control noMarginBtm"
                                                                        >
                                                                            <option selected value={0}>Select</option>
                                                                            {ItemTypeList.map((item, index) => (
                                                                                <option key={item.value} value={item.value}>
                                                                                    {item.label}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {Number(formData?.itemType) === 1 && (
                                                                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                    <div className="input-label-txt">Item per Bundle</div>
                                                                    <div className="generateSkuInputWrapper">
                                                                        <div className='flexCenter'>
                                                                            <input
                                                                                className={`form-control itemPerBundle`}
                                                                                type={"number"}
                                                                                name="itemPerBundle"
                                                                                value={formData?.itemPerBundle}
                                                                                onChange={handleFormChange}
                                                                                onBlur={handleInputBlur}
                                                                                min={0}
                                                                                disabled={view}
                                                                                onKeyDown={(evt) =>
                                                                                    ["e", "E", "+", "-"].includes(evt.key) &&
                                                                                    evt.preventDefault()
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">Product Size</div>
                                                                <div className="input-box">
                                                                    <div className="input-box">
                                                                        <input
                                                                            disabled={view}
                                                                            onChange={handleFormChange}
                                                                            value={formData?.size}
                                                                            name={"size"}
                                                                            className="form-control"
                                                                            maxLength={100}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">Seller Product Id <span className="require-field">*</span></div>
                                                                <div className="generateSkuInputWrapper">
                                                                    <div className='flexCenter'>
                                                                        <input
                                                                            disabled={view}
                                                                            onChange={handleFormChange}
                                                                            value={formData?.additionalProductId}
                                                                            name={"additionalProductId"}
                                                                            className="form-control"
                                                                            maxLength={100}
                                                                        />
                                                                        <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="additionalProductId" />
                                                                    </div>
                                                                </div>
                                                                {error.additionalProductId && (
                                                                    <div className="requiredthis">
                                                                        *This is required
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">Country of Origin <span className="require-field">*</span></div>
                                                                <div className="input-box">
                                                                    <select
                                                                        disabled={view}
                                                                        onChange={handleFormChange}
                                                                        value={formData?.countryOfOrigin}
                                                                        name={"countryOfOrigin"}
                                                                        className="form-control"
                                                                    >
                                                                        {countries?.map((country) => (
                                                                            <option key={country.id} value={country.id}>
                                                                                {country.name}
                                                                            </option>
                                                                        )
                                                                        )}
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">Product Condition <span className="require-field">*</span></div>
                                                                <div className="input-box">
                                                                    <select
                                                                        disabled={view}
                                                                        onChange={handleFormChange}
                                                                        value={formData?.inboundProductCondition_Id}
                                                                        name={"inboundProductCondition_Id"}
                                                                        className="form-control noMarginBtm"
                                                                    >
                                                                        {isCreateForm && (
                                                                            <option selected value={0}>
                                                                                Select
                                                                            </option>
                                                                        )}
                                                                        {productConditionList?.length &&
                                                                            productConditionList.map((item, index) => (
                                                                                <option key={item.id} value={item.id}>
                                                                                    {item.condition}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </div>
                                                                {error.inboundProductCondition_Id && (
                                                                    <div className="requiredthis">
                                                                        *This is required
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Package Tracking Id
                                                                </div>
                                                                <div className="input-box">
                                                                    {formData?.trackingUrl ? (
                                                                        <div className="tackingUrl d-flex justify-content-between align-items-center pl-1 pr-1">
                                                                            <a style={{maxWidth: "150px"}} rel="noreferrer" target="_blank" href={formData?.trackingUrl}>
                                                                                {" "}
                                                                                {formData?.trackingNo}
                                                                            </a>
                                                                            <Tooltip title="Click to Package">
                                                                                <button className="iconBtns btnMove" onClick={handleGotoPackage}>
                                                                                    <i className="fa fa-share-square" aria-hidden="true"></i>
                                                                                </button>
                                                                            </Tooltip>
                                                                        </div>
                                                                    ) : (
                                                                        <div className='flexCenter'>
                                                                            <input
                                                                                disabled={view}
                                                                                onChange={handleFormChange}
                                                                                value={formData?.trackingNo}
                                                                                name={"trackingNo"}
                                                                                className="form-control"
                                                                                maxLength={100}
                                                                            />
                                                                            <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="trackingNo" />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    RMA Code
                                                                </div>
                                                                <div className="input-box">
                                                                    <div className='flexCenter'>
                                                                        <input
                                                                            disabled={view}
                                                                            onChange={handleFormChange}
                                                                            value={formData?.rmaCode}
                                                                            name={"rmaCode"}
                                                                            className="form-control"
                                                                            maxLength={100}
                                                                        />
                                                                        <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="rmaCode" />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    External Platform Return Product ID
                                                                </div>
                                                                <div className="generateSkuInputWrapper">
                                                                    <div className='flexCenter'>
                                                                        <input
                                                                            disabled={view}
                                                                            onChange={handleFormChange}
                                                                            value={formData?.externalPlatformProductId}
                                                                            name={"externalPlatformProductId"}
                                                                            className="form-control"
                                                                            maxLength={100}
                                                                        />
                                                                        <BarcodeBtn handleOpenScan={handleOpenScan} fieldName="externalPlatformProductId" />
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Before processing image
                                                                </div>
                                                                <div>
                                                                    <div className="fileUpload">
                                                                        <button
                                                                            disabled={view}
                                                                            type="button"
                                                                            className="btn cus-seconday-bg-btn"
                                                                        >
                                                                            Upload image
                                                                        </button>
                                                                        <input
                                                                            className="hiddenFileField"
                                                                            onChange={handleImageUpload}
                                                                            disabled={view}
                                                                            type="file"
                                                                            id="customFilebefore"
                                                                            multiple
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        {image.length > 0 &&
                                                                            image.map((item, index) => (
                                                                                <div
                                                                                    className="selectedFile"
                                                                                    key={item?.id}
                                                                                >
                                                                                    <div className="fileName">{item.name}</div>
                                                                                    <button
                                                                                        onClick={() => handleDeleteImage(index)}
                                                                                    >
                                                                                        <i
                                                                                            className="fa fa-times"
                                                                                            aria-hidden="true"
                                                                                        ></i>
                                                                                    </button>
                                                                                </div>
                                                                            ))}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    After processing Image
                                                                </div>
                                                                <div>
                                                                    <div className="fileUpload">
                                                                        <button
                                                                            disabled={view}
                                                                            type="button"
                                                                            className="btn cus-seconday-bg-btn"
                                                                        >
                                                                            Upload image
                                                                        </button>
                                                                        <input
                                                                            className="hiddenFileField"
                                                                            onChange={handleAfterImageUpload}
                                                                            disabled={view}
                                                                            type="file"
                                                                            id="customFileafter"
                                                                            multiple
                                                                        />
                                                                    </div>

                                                                    <RenderImages
                                                                        afterImage={afterImage}
                                                                        setAfterImage={setAfterImage}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Video (format: mp4, avi, mov)
                                                                </div>
                                                                <div>
                                                                    <div className="fileUpload">
                                                                        <button
                                                                            disabled={view}
                                                                            type="button"
                                                                            className="btn cus-seconday-bg-btn"
                                                                        >
                                                                            Upload Video
                                                                        </button>
                                                                        <input
                                                                            ref={videoInputRef}
                                                                            className="hiddenFileField"
                                                                            onChange={(e) => {
                                                                                handleVideoUpload(e);
                                                                                setIsFormEdited(true);
                                                                            }} // Modify the function name here
                                                                            disabled={view}
                                                                            type="file"
                                                                            id="customFile"
                                                                            multiple
                                                                        />
                                                                    </div>
                                                                    {formData?.videoUrl && (
                                                                        <div className="selectedFile">
                                                                            <div className="fileName">
                                                                                {formData?.video}
                                                                            </div>
                                                                            <a
                                                                                href={formData?.videoUrl}
                                                                                target="_blank"
                                                                                rel="noreferrer"
                                                                            >
                                                                                {formData?.video}
                                                                            </a>
                                                                            {!view && (
                                                                                <button onClick={handleUpdateDeleteVideo}>
                                                                                    <i
                                                                                        className="fa fa-times"
                                                                                        aria-hidden="true"
                                                                                    ></i>
                                                                                </button>
                                                                            )}
                                                                        </div>
                                                                    )}

                                                                    <RenderVideos
                                                                        video={video}
                                                                        formData={formData}
                                                                        setVideo={setVideo}
                                                                        videoInputRef={videoInputRef}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">Upload Attachments</div>
                                                                <div>
                                                                    <div className="fileUpload">
                                                                        <button
                                                                            disabled={view}
                                                                            type="button"
                                                                            className="btn cus-seconday-bg-btn"
                                                                        >
                                                                            Upload Docs
                                                                        </button>
                                                                        <input
                                                                            className="hiddenFileField"
                                                                            onChange={(e) => {
                                                                                setIsFormEdited(true);
                                                                                handleDocsUpload(e, toast, error, setErrors, setAttachments, attachments)
                                                                            }}
                                                                            disabled={view}
                                                                            type="file"
                                                                            id="customFileafter"
                                                                            multiple
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        {attachments.length > 0 &&
                                                                            attachments.map((item, index) => (
                                                                                <>
                                                                                    {!item.isDeleted && (
                                                                                        <div
                                                                                            className="selectedFile mr-2"
                                                                                            key={item?.id}
                                                                                        >
                                                                                            <div className="fileName">
                                                                                                <a href={item.fileUrl} target="_blank" rel="noreferrer">{item.name}</a>
                                                                                            </div>
                                                                                            <button
                                                                                                onClick={() =>
                                                                                                    handleDeleteAfterImage(index, 'attachments')
                                                                                                }
                                                                                                disabled={view}
                                                                                            >
                                                                                                <i
                                                                                                    className="fa fa-times"
                                                                                                    aria-hidden="true"
                                                                                                ></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>

                                                <Accordion.Item eventKey="1">
                                                    <Accordion.Header>
                                                        Technicals {" "}
                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className="row addressForm pl-3 pr-3">
                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Incoming Date
                                                                </div>
                                                                <div>
                                                                    <DatePicker
                                                                        disabled={view}
                                                                        className="form-control receivedDate"
                                                                        onChange={(receivedDate) =>
                                                                            handleDateChange(receivedDate, "incomingDate")
                                                                        }
                                                                        showIcon
                                                                        value={moment(formData?.incomingDate).format(
                                                                            "MM-DD-YYYY"
                                                                        )}
                                                                        name={"incomingDate"}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">Status <span className="require-field">*</span></div>
                                                                <div>
                                                                    <select
                                                                        disabled={view}
                                                                        onChange={handleFormChange}
                                                                        value={formData?.inboundProductStatus_Id}
                                                                        name={"inboundProductStatus_Id"}
                                                                        className="form-control noMarginBtm"
                                                                    >
                                                                        {isCreateForm && (
                                                                            <option value={0} selected>
                                                                                Select
                                                                            </option>
                                                                        )}
                                                                        {productStatusList?.length &&
                                                                            productStatusList.map((item, index) => (
                                                                                <option key={item.id} value={item.id}>
                                                                                    {item.status}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </div>
                                                                {error.inboundProductStatus_Id && (
                                                                    <div className="error">
                                                                        *This is required
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Process Type
                                                                </div>
                                                                <div>
                                                                    <select
                                                                        disabled={view}
                                                                        onChange={handleFormChange}
                                                                        value={formData?.inboundProductProcessType_Id}
                                                                        name={"inboundProductProcessType_Id"}
                                                                        className="form-control noMarginBtm"
                                                                    >
                                                                        {isCreateForm && (
                                                                            <option selected value>
                                                                                Select
                                                                            </option>
                                                                        )}
                                                                        {productProcessList?.length &&
                                                                            productProcessList.map((item, index) => (
                                                                                <option key={item.id} value={item.id}>
                                                                                    {item.processType}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Processing Date{" "}
                                                                </div>
                                                                <div>
                                                                    <DatePicker
                                                                        disabled
                                                                        className="form-control receivedDate"
                                                                        dateFormat="MM-dd-yyyy"
                                                                        onChange={(receivedDate) =>
                                                                            handleDateChange(receivedDate, "processingDate")
                                                                        }
                                                                        showIcon
                                                                        value={
                                                                            formData?.processingDate || isCreateForm
                                                                                ? moment(formData?.processingDate).format(
                                                                                    "MM-DD-YYYY"
                                                                                )
                                                                                : null
                                                                        }
                                                                        name={"processingDate"}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Ship Date{" "}
                                                                </div>
                                                                <div>
                                                                    <DatePicker
                                                                        disabled
                                                                        className="form-control receivedDate"
                                                                        dateFormat="MM-dd-yyyy"
                                                                        onChange={(receivedDate) =>
                                                                            handleDateChange(receivedDate, "shipDate")
                                                                        }
                                                                        showIcon
                                                                        value={
                                                                            formData?.shipDate || isCreateForm
                                                                                ? moment(formData?.shipDate).format(
                                                                                    "MM-DD-YYYY"
                                                                                )
                                                                                : null
                                                                        }
                                                                        name={"shipDate"}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                                                                <div className="input-label-txt">
                                                                    Packing Supplies
                                                                </div>
                                                                <div className="input-box">
                                                                    <input
                                                                        disabled={view}
                                                                        onChange={handleFormChange}
                                                                        value={formData?.packingSupplies}
                                                                        name={"packingSupplies"}
                                                                        className="form-control"
                                                                        maxLength={100}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>

                                                <Accordion.Item eventKey="2">
                                                    <Accordion.Header>
                                                        Warehouse {" "}
                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        {formData?.wareHouseDetails?.length === 0 && (
                                                            <button
                                                                className="addplusicon"
                                                                onClick={addWarehouse}
                                                                disabled={view}
                                                            >
                                                                <i className="fa fa-plus-circle fsIcon" aria-hidden="true"></i>
                                                            </button>
                                                        )}
                                                        {formData?.wareHouseDetails?.map((item, index) => (
                                                            <WarehouseDetails
                                                                item={item}
                                                                key={item.id}
                                                                isEditable={!view}
                                                                handleInputBlur={handleInputBlur}
                                                                addWarehouse={addWarehouse}
                                                                index={index}
                                                                removeWarehouse={removeWarehouse}
                                                                productForm={formData}
                                                                setProductForm={setFormData}
                                                                handleWarehouse={handleWarehouse}
                                                                updateWareHouseDetails={updateWareHouseDetails}
                                                                error={error}
                                                                userDetails={userDetails}
                                                                isProduct={true}
                                                            />
                                                        ))}
                                                    </Accordion.Body>
                                                </Accordion.Item>

                                                <Accordion.Item eventKey="3">
                                                    <Accordion.Header>
                                                        Notes {" "}
                                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <div className="row addressForm pl-3 pr-3">
                                                            <div className="col-12">
                                                                <div className="input-label-txt">Notes</div>
                                                                <textarea
                                                                    disabled={view}
                                                                    type={"text"}
                                                                    name="notes"
                                                                    value={formData?.notes}
                                                                    className="form-control incomingTextarea"
                                                                    onChange={handleFormChange}
                                                                    maxLength={200}
                                                                />
                                                                {error.notes && (
                                                                    <div className="requiredthis">
                                                                        *This is required
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        </Col>
                                    </Row>
                                </div>

                                {parseInt(id) !== 0 && ( // NOSONAR
                                    <div className="col-4">
                                        <div className="row mt-2">
                                            <div className="col-lg-6 col-sm-12">
                                                <h5 className="subHeadingInner2">Before Processing</h5>
                                                {formData?.beforeProcessingImages?.length > 0 ? (
                                                    <ImageSlider
                                                        isView={view}
                                                        handleMarkPrimary={handleMarkPrimary}
                                                        handleDeleteImage={handleSliderDeleteImage}
                                                        images={formData?.beforeProcessingImages.filter(
                                                            (item) => !item.isDeleted
                                                        )}
                                                        isUserAdmin={isSuperAdminUser}
                                                        setShowLargeSliderModal={setShowBeforeProcessingModal}
                                                        showLargeSliderModal={showBeforeProcessingModal}
                                                    />
                                                ) : (
                                                    <img src={noImage} alt="" />
                                                )}
                                            </div>
                                            <div className="col-lg-6 col-sm-12">
                                                <h5 className="subHeadingInner2">After Processing</h5>
                                                {formData?.afterProcessingImages?.length ? (
                                                    <ImageSlider
                                                        isView={view}
                                                        handleMarkPrimary={handleMarkPrimary}
                                                        images={formData?.afterProcessingImages.filter(
                                                            (item) => !item.isDeleted
                                                        )}
                                                        handleDeleteImage={handleSliderDeleteImage}
                                                        isUserAdmin={isSuperAdminUser}
                                                        setShowLargeSliderModal={setShowAfterProcessingModal}
                                                        showLargeSliderModal={showAfterProcessingModal}
                                                    />
                                                ) : (
                                                    <img src={noImage} alt="" />
                                                )}
                                            </div>
                                        </div>
                                        <div className="row">
                                            {formData.inboundParcelId > 0 && formData?.parcelImages?.length > 0 && (
                                                <div className="col-12 mt-3">
                                                    <button
                                                        type="button"
                                                        className="sortBtn subHeadingInner2 linkIntegration ml-0 mb-1"
                                                        title="Go to package"
                                                        onClick={handleGotoPackage}
                                                        >
                                                        Package Images
                                                    </button>
                                                    {formData?.parcelImages?.length > 0 ? (
                                                        <ImageSlider
                                                            isView={view}
                                                            images={formData?.parcelImages}
                                                            isUserAdmin={isSuperAdminUser}
                                                            setShowLargeSliderModal={setShowPackageImagesModal}
                                                            showLargeSliderModal={showPackageImagesModal}
                                                        />
                                                    ) : (
                                                        <div className="alignCenter1">
                                                            <img src={noImage} alt="" style={{maxHeight: '200px'}}/>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BarcodeScannerComponent
                setShowScanner={setShowScanner}
                showScanner={showScanner}
                handleScanSuccess={handleScanSuccess}
            />
            {formData?.beforeProcessingImages?.length > 0 &&
                <InLargeImageSlider
                    popupTitle={'Product'}
                    view={view}
                    handleMarkPrimary={handleMarkPrimary}
                    images={formData?.beforeProcessingImages.filter(
                        (item) => !item.isDeleted
                    )}
                    handleDeleteImage={handleSliderDeleteImage}
                    isUserAdmin={isSuperAdminUser}
                    showModal={showBeforeProcessingModal}
                    setShowLargeSliderModal={setShowBeforeProcessingModal}
                />
            }

            {formData?.afterProcessingImages?.length > 0 &&
                <InLargeImageSlider
                    popupTitle={'Product'}
                    view={view}
                    handleMarkPrimary={handleMarkPrimary}
                    images={formData?.afterProcessingImages.filter(
                        (item) => !item.isDeleted
                    )}
                    handleDeleteImage={handleSliderDeleteImage}
                    isUserAdmin={isSuperAdminUser}
                    showModal={showAfterProcessingModal}
                    setShowLargeSliderModal={setShowAfterProcessingModal}
                />
            }
            {formData?.parcelImages?.length > 0 &&
                <InLargeImageSlider
                    popupTitle={'Package Images'}
                    view={true}
                    images={formData?.parcelImages}
                    isUserAdmin={isSuperAdminUser}
                    showModal={showPackageImagesModal}
                    setShowLargeSliderModal={setShowPackageImagesModal}
                />
            }

            <AddTaskModal
                show={showAddTaskModal}
                handleCancel={() => setShowAddTaskModal(false)}
                productContext={{
                    sku: formData?.sku,
                    productName: formData?.itemName,
                    availableQty: (formData?.wareHouseDetails || []).reduce(
                        (sum, w) => sum + (Number(w?.quantity) || 0),
                        0
                    ),
                    inboundProductId: Number(id) || 0,
                    companyId: formData?.companyId || 0,
                    sellerId: formData?.sellerId || 0,
                    referenceType: 'Product',
                    referenceId: Number(id) || 0,
                }}
            />
            <PostChargesModal
                show={showPostChargesModal}
                handleCancel={() => setShowPostChargesModal(false)}
                productContext={{
                    sku: formData?.sku,
                    productName: formData?.itemName,
                    availableQty: (formData?.wareHouseDetails || []).reduce(
                        (sum, w) => sum + (Number(w?.quantity) || 0),
                        0
                    ),
                    sellerName: sellerList?.find((s) => s.value === formData?.sellerId)?.label,
                    inboundProductId: Number(id) || 0,
                    companyId: formData?.companyId || 0,
                    sellerId: formData?.sellerId || 0,
                    referenceType: 'Product',
                    referenceId: Number(id) || 0,
                    returnProductSku: formData?.sku,
                }}
            />
            <TasksChargesHistoryModal
                show={showHistoryModal}
                handleCancel={() => setShowHistoryModal(false)}
                productContext={{
                    sku: formData?.sku,
                    productName: formData?.itemName,
                    sellerName: sellerList?.find((s) => s.value === formData?.sellerId)?.label,
                    referenceType: 'Product',
                    referenceId: Number(id) || 0,
                }}
            />

        </main>
    );
};

export default EditProduct;
